import React, { forwardRef, useMemo } from 'react';
import { Select } from 'antd';

const DatabaseSelect = forwardRef(({ availableDatabases, onChange, value: databases }, ref) => {
	const dbValues = useMemo(() => {
		if (availableDatabases && databases) {
			return availableDatabases
				.filter((item) => databases.includes(item.key.toUpperCase()))
				.map((item) => item.key);
		} else {
			return [];
		}
	}, [availableDatabases]);

	if (!availableDatabases) {
		return null;
	}

	return (
		<Select
			mode='multiple'
			optionFilterProp='label'
			defaultValue={dbValues}
			onChange={onChange}
			ref={ref}
		>
			{availableDatabases.map((db) => (
				<Select.Option key={db.key} value={db.key} label={db.name}>
					{db.name}
				</Select.Option>
			))}
		</Select>
	);
});

export default DatabaseSelect;



// WEBPACK FOOTER //
// ./src/components/DatabaseSelect.jsx